import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TileService } from "../../../widgets/services/tile.service";

@Component({
  selector: 'app-miro-callback',
  standalone: true,
  imports:[],
  templateUrl: './miro-callback.component.html',
  styleUrls: ['./miro-callback.component.scss']
})
export class MiroCallBackComponent implements OnInit {
  constructor(private route: Router, private tileService: TileService) { }

 async ngOnInit(){
    if (this.route.url.includes("code")) {
      var redirectUrl = this.route.url.replace('/miro', '');
      var formData = new FormData();
      formData.append('queryString', JSON.stringify(redirectUrl));
      await this.tileService.saveMiroToken(formData).then((data) => {
        window.close();
      }).catch((value) => {
        window.close();
      });
    }
  }
}
